module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./ProductsView.js"));
	}, "CouponRecordView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CouponRecordView!./src/pages/Shop/Member/Wallet/Coupon/Products/ProductsView.js
// module id = 1591
// module chunks = 418